<template>
  <v-dialog v-model="show" persistent max-width="290">
    <v-card>
      <v-card-title class="headline">Esta seguro?</v-card-title>
      <v-card-text
        >Esta seguro que desea realizar esta accion blaa blaa blaa.</v-card-text
      >
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="red darken-1"
          flat
          @click.prevent="show = deleteProveedorClose()"
          >Cancelar</v-btn
        >
        <v-btn color="green darken-1" flat @click="show = false">Aceptar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import axios from "axios";
export default {
  name: "delete-proveedor",
  props: {
    id: Number,
    dialogDelete: Boolean,
  },
  data() {
    return {
      show: Boolean,
    };
  },
  methods: {
    updateProvider() {},

    deleteProveedorClose() {
      this.$parent.dialogDelete = false;
      this.show = false;
    },
  },
  computed: {},
  mounted() {},
  created() {
    this.show = this.dialogDelete;
  },
};
</script>
